import { z } from 'zod';

export enum AmpereUnit {
  A = 0,
  KA = 3,
  MA = 6,
}

export const AmpereUnitSchema = z.nativeEnum(AmpereUnit);
